/* global BX, bitrix_sessid, FormUtils */

import {closeBasket} from './basket-fly/open-basket-fly.js';

(function () {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;

    const modalId = 'buy-one-click-modal-overlay';
    const closeBtnId = 'buy-one-click-form-header-btn';
    const submitBtn = document.getElementById('buy-one-click-submit-btn');
    const commonErrorsBlock = document.getElementById('buy-one-click-form-common-errors');
    const containerSelector = '';
    const MIN_ORDER_AMOUNT = 500;
    const captchaContainerId = 'captcha-container-question';

    let defaultDeliveryHref = null;
    let activeTriggerBtn = null;

    const fullname = document.getElementById('fullname-buy-one-click');
    const phone = document.getElementById('phone-buy-one-click');
    const email = document.getElementById('email-buy-one-click');
    const message = document.getElementById('message-buy-one-click');

    if (!document.getElementById(modalId) || !submitBtn) return;

    FormUtils.setupPhoneMask(phone);

    const initCaptcha = () => FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = () => FormUtils.resetCaptcha();

    const clearFields = () => {
        fullname.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
    };

    const hideErrors = () => {
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };

    const validate = () => {
        let isValid = true;
        hideErrors();

        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, '*Обязательное поле');
            isValid = false;
        }

        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, '*Введите корректный номер телефона (не менее 10 цифр)');
            isValid = false;
        }

        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, '*Введите корректный E-mail');
            isValid = false;
        }

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, 'Пожалуйста, подтвердите, что вы не робот');
            isValid = false;
        }

        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };

    const getBasketItemsData = () => {
        const basket = window.BX?.Sale?.BasketComponent;
        if (basket && basket.result && basket.result.BASKET_ITEM_RENDER_DATA) {
            return basket.result.BASKET_ITEM_RENDER_DATA.map((item) => ({
                id: item.PRODUCT_ID,
                quantity: parseFloat(item.QUANTITY) || 1,
                price: parseFloat(item.PRICE) || 0,
            }));
        }
        return [];
    };

    const getOrderInfo = () => {
        const isMassOrder = activeTriggerBtn?.classList.contains('open-buy-one-click--mas');

        if (isMassOrder) {
            const items = getBasketItemsData();
            const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

            return {
                isMassOrder: true,
                items: items.map((item) => ({id: item.id, quantity: item.quantity})),
                total: total,
            };
        }

        const openBtn =
            document.querySelector('.catalog-detail__one-click .open-buy-one-click') ||
            document.querySelector('.open-buy-one-click');
        const counter = document.getElementById('basket-counter');
        const quantityInputId = openBtn?.getAttribute('data-quantity-input-id');
        const quantityInput = quantityInputId
            ? document.getElementById(quantityInputId)
            : counter?.querySelector('.counter__digit');

        const productId =
            openBtn?.getAttribute('data-product-id') ||
            document.getElementById('product-info-block')?.dataset.productId ||
            document.getElementById('productId')?.value ||
            '';

        const baseQuantity = parseFloat(String(quantityInput?.value ?? '1').replace(',', '.')) || 1;

        const flyInput =
            document.getElementById('emergency-fly-counter') || document.querySelector('.basket-fly__item-counter');
        const flyQuantity = flyInput ? parseFloat(String(flyInput.value).replace(',', '.')) || 1 : 0;

        const quantity = Math.max(baseQuantity, flyQuantity);

        let price = 0;
        if (counter?.dataset.price) {
            price = parseFloat(String(counter.dataset.price).replace(',', '.')) || 0;
        } else {
            const metaPrice = document.querySelector('[itemprop="price"]');
            price = parseFloat(metaPrice?.content || '0') || 0;
        }

        return {isMassOrder: false, productId, quantity, price, total: price * quantity};
    };

    const validateMinOrderAmount = () => {
        const {total} = getOrderInfo();

        if (total < MIN_ORDER_AMOUNT) {
            FormUtils.showCommonError(commonErrorsBlock, 'Минимальная сумма заказа 500 рублей');
            FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
            return false;
        }

        return true;
    };

    const clearBasketAfterOrder = () => {
        const removeAllBtn =
            document.querySelector('.remove_all_basket[data-type="basket"]') ||
            document.querySelector('.remove_all_basket');

        const removeBasket = document.getElementById('basket__button-clear');

        if (removeAllBtn) {
            removeAllBtn.click();
        } else if (removeBasket) {
            removeBasket.click();
        } else if (window.BX?.onCustomEvent) {
            BX.onCustomEvent('onCompleteAction', [{action: 'loadBasket'}]);
        }
    };

    const send = async () => {
        if (!validate()) return;
        if (!validateMinOrderAmount()) return;

        const orderInfo = getOrderInfo();
        const token =
            typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';
        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);

        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : '',
        };

        payload.items = orderInfo.isMassOrder
            ? orderInfo.items
            : [{id: orderInfo.productId, quantity: orderInfo.quantity}];

        if (submitBtn) submitBtn.disabled = true;

        try {
            const response = await fetch('/api/v1/order/buy-one-click', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(payload),
            });

            const rawText = await response.text();
            const jsonMatch = rawText.match(/\{[\s\S]*\}/);

            if (jsonMatch) {
                const result = JSON.parse(jsonMatch[0]);
                if (result.success || result.orderId) {
                    alert(result.message || `Спасибо! Ваш заказ №${result.orderId} успешно принят.`);
                    clearBasketAfterOrder();
                    close();
                    return;
                }
            }

            FormUtils.showCommonError(commonErrorsBlock, 'Ошибка при обработке заказа на сервере.');
            FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        } catch (e) {
            console.error(e);
            FormUtils.showCommonError(commonErrorsBlock, 'Ошибка сети. Проверьте соединение и попробуйте снова.');
            FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        } finally {
            if (submitBtn) submitBtn.disabled = false;
        }
    };

    const initDeliveryHref = () => {
        const href = document.getElementById('deliveryLink');
        if (href) {
            defaultDeliveryHref = document.getElementById('deliveryLink').outerHTML;
            href.addEventListener('click', (e) => {
                e.preventDefault();
                href.outerHTML =
                    '<span id="deliveryLink" style="display: inline-block; max-width: 265px;" class="simple-text--font">В стоимость заказа может быть включена ' +
                    '<a href="/help/delivery" target="_blank" rel="noopener noreferrer">цена доставки</a></span>';
            });
        }
    };

    const getDefaultDeliveryHref = () => {
        const href = document.getElementById('deliveryLink');
        if (href) {
            href.outerHTML = defaultDeliveryHref;
        }
    };

    const open = () => {
        const basketContainer = document.querySelector('.basket_fly, .basket-fly');
        if (basketContainer) {
            closeBasket(basketContainer);
        }

        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initDeliveryHref();
        initCaptcha();
        resetCaptcha();

        setTimeout(() => {
            const fone = document.querySelector('.jqmOverlay');
            if (fone) {
                fone.remove();
            }
        }, 50);
    };

    const close = () => {
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        getDefaultDeliveryHref();
        resetCaptcha();
        activeTriggerBtn = null;
    };

    FormUtils.createModal({
        modalId,
        closeBtnId,
        onOpen: open,
        onClose: close,
    });

    document.addEventListener('click', (e) => {
        const targetBtn = e.target.closest('.open-buy-one-click');

        if (targetBtn) {
            e.preventDefault();
            activeTriggerBtn = targetBtn;
            open();
        }
    });

    submitBtn.addEventListener('click', send);
})();
